import './ConfirmSwapPagesModal.pcss';
import React from 'react';
import BasicModalTemplate from '../../../../../common/modals/BasicModalTemplate';
import { ConfirmSwapPagesModalParams } from '@mm/state/modules/modalsState/actions';
import { ModalInstanceProps } from '../../../../../common/modals/interfaces';

type Props = ConfirmSwapPagesModalParams & ModalInstanceProps;

const ConfirmSwapPagesModal = (props: Props) => {
  const { facebookPage } = props;

  return (
    <BasicModalTemplate
      className="confirm-swap-pages-modal"
      withMonkeyBackground={false}
      iconClass="confirm-swap-pages-modal__close-icon"
    >
      <div className="confirm-swap-pages-modal__body">
        <div className="confirm-swap-pages-modal__header-text">
          <i className="fas fa-check-circle confirm-swap-pages-modal__check" />
          <p className="confirm-swap-pages-modal__header-text-heading">
            All Set!
          </p>
        </div>
        <div className="confirm-swap-pages-modal__note">
          Your subscription has just been moved to <b>{facebookPage.name}</b>
        </div>
      </div>
    </BasicModalTemplate>
  );
};

export default ConfirmSwapPagesModal;
